<template>
  <div id="withdraw_message">
    <van-col span="24" class="withdraw_message_bg">
      <!-- 顶部导航栏 -->
      <van-nav-bar :title="$t('title.withdraw_message')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
      <!-- 订单状态 -->
      <van-col span="24">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="$t('other.there_is_no_more')"
            :loading-text="$t('other.Loading')"
            @load="onLoad"
        >
          <van-cell v-for="(t,i) in list" :key="i" >
            <!-- 订单金额 -->
            <van-col span="24" class="withdraw_message_time"> {{ shouldShowTime(t.show_time, i) }}</van-col>
            <van-col span="24" class="withdraw_message_centent">
              <van-col span="4" class="withdraw_message_centent_left">
                <img src="../assets/img/withdraw_message_icon.png"/>
              </van-col>
              <van-col span="17" class="withdraw_message_centent_right">
                <van-col span="22" offset="1" class="withdraw_message_centent_right_title"> {{ t.title }} </van-col>
                 <van-col span="22" offset="1" v-if="t.order_status =='4'">
                    <van-col span="24" class="withdraw_message_centent_right_amount">
                      <span class="withdraw_message_centent_right_amount_title">{{$t('column.amount_details')}}:</span> 
                      <span class="withdraw_message_centent_right_amount_value">${{ t.order_dollar_amount }}= <img src="../assets/img/coin9.png"/> {{ t.order_amount }}</span>
                     </van-col>
                    <van-col span="24" class="withdraw_message_centent_right_order_number"> {{ $t('column.order_number')}}: <span>{{ t.order_id }}</span> </van-col>
                    <van-col span="24" class="withdraw_message_centent_right_bottom">
                      <van-cell :title="t.order_status === '0' || t.order_status === '1' ? $t('column.to_confirm'): $t('column.check_details')" is-link @click="detailsOrder(t)" />
                    </van-col>
                 </van-col>
                <van-col span="22" offset="1" v-else>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_status">
                    {{ $t('column.status') }}
                    <van-tag type="warning" round  :color="shouldShowColor(t.order_status)">
                      <img src="../assets/img/approve_order_status.png" v-if="t.order_status ==='0'"/>
                      <img src="../assets/img/approve_order_status1.png" v-else-if="t.order_status ==='1'"/>
                      <img src="../assets/img/approve_order_status3.png" v-else-if="t.order_status ==='3'"/>
                      <img src="../assets/img/approve_order_status4.png" v-else/>
                      {{ t.status_text }}
                    </van-tag>
                  </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_text">{{ t.content }}</van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_payment">{{ $t('column.payment_amount') }} </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_money"> {{ t.payment_amount }} </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_payment"> {{ $t('column.payment_method') }} </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_payment_img">  <img :src="t.url"/> </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_payment"> {{　$t('column.apply_time')　}} </van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_money"> {{ t.addtime }}</van-col>
                  <van-col span="22" offset="1" class="withdraw_message_centent_right_bottom">
                    <van-cell :title="t.order_status === '0' || t.order_status === '1' ? $t('column.to_confirm'): $t('column.check_details')" is-link @click="detailsOrder(t)" />
                  </van-col>
                </van-col>
                
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-col>

  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import axios from "axios";
import { Dialog } from "vant";

export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      page: 1,
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    shouldShowColor(status){
      switch ( status) {
        case '0':
          return '#FFF0FD'
        case '1':
          return '#FFF7E2'
        case '3':
          return '#F1FFF6'
        default:
          return '#e0e0e0'
      }
    },
    shouldShowTime(currentTime, index) {
      // 第一条消息总是显示时间
      if (index === 0) return this.formatTime(currentTime);
      const prevTime = this.list[index - 1].show_time;
      const timeDiff =  prevTime - currentTime;
      // 检查是否超过5分钟（300秒）
      console.log('timeDiff=' + timeDiff)
      if (timeDiff > 300) {
        return this.formatTime(currentTime);
      }
      return '';
    },

    formatTime(timestamp) {
      const date = new Date(timestamp * 1000);
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const period = hours >= 12 ? 'PM' : 'AM';
      const hour12 = hours % 12 || 12;
      const minuteStr = minutes < 10 ? '0' + minutes : minutes;
      // 判断日期
      if (date >= today) {
        // 今天 - 显示时间
        return `${hour12}:${minuteStr} ${period}`;
      } else {
        // 更早日期
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${month}/${day} ${hour12}:${minuteStr} ${period}`;
      }
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1) {
        this.get_list()
      }
    },
    get_list(){
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=user_center&act=withdraw_message_list",{
        params:{
          uid: uid,
          token: token,
          page: this.page
        }
      }).then(res =>{
        this.loading = false;
        if(res.data.status ===1){
          if (this.page === 1) {
            this.list = []
          }
          for (let j = 0; j < res.data.list.length; j++) {
            this.list.push(res.data.list[j])
          }
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.list.length < 10) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      window.location.href="bogolive://exit"
    },
    detailsOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      if (o.order_status === '0' || o.order_status === '1') {
        this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: o.order_id } })
      }else{
        this.$router.push({ path: '/withdraw_payroll', query: { uid: uid, token: token,source: 'h5' } })
      }
    }
  }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/components/withdraw_message.vue